const CUSTOMER_TYPE_LIST = [
    { value: 1, name: 'Credential Customer' },
    { value: 2, name: 'Software Customer' },
];

export default CUSTOMER_TYPE_LIST;
